export default "__VITE_ASSET__Bfg4oGLO__"